import React from 'react';
import { Box, Text } from '@wix/design-system';
import { clsx } from 'clsx';
import s from './MarqueeBanner.scss';
export const MarqueeBanner = _ref => {
  let items = _ref.items,
    dataHook = _ref.dataHook,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? '4px' : _ref$gap,
    _ref$coloredItems = _ref.coloredItems,
    coloredItems = _ref$coloredItems === void 0 ? false : _ref$coloredItems,
    _ref$sizedIcon = _ref.sizedIcon,
    sizedIcon = _ref$sizedIcon === void 0 ? false : _ref$sizedIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: s.container,
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.track,
    verticalAlign: "middle"
  }, ['a', 'b', 'c', 'd'].map(copy => items.map(_ref2 => {
    let id = _ref2.id,
      Icon = _ref2.Icon,
      text = _ref2.text;
    return /*#__PURE__*/React.createElement(Box, {
      key: `${id}-${copy}`,
      className: clsx(s.item, coloredItems && s.colored),
      gap: gap,
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: sizedIcon ? s.icon : undefined
    }), /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, text));
  }))));
};
//# sourceMappingURL=MarqueeBanner.js.map